/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/
export class CatlistForm {
  public limit: number;
  public offset: number;
  public count: number;
  public vendorId: number;
  constructor(catlistForm: any) {
    this.limit = catlistForm.limit || '';
    this.offset = catlistForm.offset || '';
    this.count = catlistForm.count || '';
    this.vendorId = catlistForm.vendorId || '';
  }
}
